/**
 * 顧客詳細パネルラッパーコンポーネント
 *
 * 顧客選択時の詳細表示と未選択時のプレースホルダーを管理
 */

import { Paper, Box, Text, Center, Stack, ScrollArea } from "@mantine/core";
import { Customer } from "../../services/customerService";
import { CustomerDetailPanel } from "../CustomerDetailPanel";

interface CustomerDetailWrapperProps {
  customer: Customer | null;
}

/**
 * 顧客詳細パネルラッパー
 */
export function CustomerDetailWrapper({ customer }: CustomerDetailWrapperProps) {
  return (
    <Paper
      shadow="xs"
      radius="md"
      withBorder
      style={{
        flex: 1,
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      <ScrollArea style={{ flex: 1 }} offsetScrollbars>
        <Box p="md">
          {customer ? (
            <CustomerDetailPanel customer={customer} />
          ) : (
            <Center h="300px">
              <Stack align="center" gap="md">
                <Text c="dimmed" size="lg">
                  顧客を選択してください
                </Text>
                <Text c="dimmed" size="sm">
                  左側のリストから顧客を選択すると、詳細設定が表示されます。
                </Text>
              </Stack>
            </Center>
          )}
        </Box>
      </ScrollArea>
    </Paper>
  );
}
